import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError from 'layers/errorHandling/apiError/component'
import {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'
import {
  operations as siteOperations,
  selectors as siteSelectors,
  actions as siteActions,
} from 'store/siteManager'
import { Formik } from 'formik'
import { validationSchema, fieldNames } from './data'

import PurposeModalComponent from './component'

export const PurposeModalContainer = ({
  clearError,
  flowLabel,
  handleCancel,
  hasApiError,
  handleClose,
  modals,
  site,
  purpose,
  purposeIsCompleted,
  updateSitePreferences,
}) => {
  const [currentStep, setCurrentStep] = useState(purposeIsCompleted ? 1 : 0)

  const handleStepChange = toStep => setCurrentStep(toStep)
  const goBack = () => {
    handleStepChange(currentStep - 1)
  }

  const handleSave = async (values, isComplete) => {
    const newSitePreferences = {
      k5Digital: {
        purpose: values.purpose,
        purposeIsCompleted: isComplete,
      },
      mspDigital: {
        purpose: values.purpose,
        purposeIsCompleted: isComplete,
      },
    }
    await updateSitePreferences(site.id, newSitePreferences)
  }

  const closeModal = () => {
    clearError('sitePreferences')
    handleClose()
  }

  const initialValues = {
    purpose: purpose || '',
  }

  return (
    <Formik
      enableReinitialize={true}
      initialIsValid={validationSchema.isValidSync(initialValues)}
      initialTouched={{
        purpose: !!purpose,
      }}
      initialValues={initialValues}
      validationSchema={validationSchema}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        setSubmitting,
        setTouched,
        isSubmitting,
        isValid,
      }) => (
        <PurposeModalComponent
          currentStep={currentStep}
          errors={errors}
          flowLabel={flowLabel}
          goBack={() => goBack()}
          handleCancel={handleCancel}
          handleCancelButtonClick={async (shouldSave, isComplete) => {
            if (shouldSave) {
              setSubmitting(true)
              await handleSave(values, isComplete)
              setSubmitting(false)
            }
            closeModal()
          }}
          handleChange={(name, value) => {
            setFieldTouched(name)
            setFieldValue(name, value)
          }}
          handleClose={closeModal}
          handleNextButtonClick={async (shouldSave, isComplete) => {
            const isValidSync = validationSchema.isValidSync(values)
            if (shouldSave && !isValidSync) {
              const touchedFields = fieldNames.reduce((acc, name) => {
                acc[name] = true
                return acc
              }, {})
              await setTouched(touchedFields)
              return
            }
            if (shouldSave) {
              setSubmitting(true)
              await handleSave(values, isComplete)
              setSubmitting(false)
            }
            if (purposeIsCompleted) {
              closeModal()
            } else {
              handleStepChange(currentStep + 1)
            }
          }}
          hasApiError={hasApiError}
          isSubmitting={isSubmitting}
          isValid={isValid}
          modals={modals}
          purposeIsCompleted={purposeIsCompleted}
          touched={touched}
          values={values}
        />
      )}
    </Formik>
  )
}

const mapStateToProps = (state, ownProps) => {
  const site = siteSelectors?.selectSiteById(state, ownProps.siteId)
  const { sitePreferences = {} } = site || {}
  const { k5Digital = {} } = sitePreferences
  const { purpose, purposeIsCompleted } = k5Digital
  const { sitePreferences: sitePreferencesAPIResults } = state.siteManager
  const { error } = sitePreferencesAPIResults

  return {
    hasApiError: !!error,
    site,
    purpose,
    purposeIsCompleted,
  }
}

const mapDispatchToProps = {
  updateSitePreferences: siteOperations.updateSitePreferences,
  clearError: siteActions.clearError,
}

PurposeModalContainer.propTypes = {
  clearError: PropTypes.func,
  dispatch: PropTypes.func,
  flowLabel: PropTypes.string,
  handleCancel: PropTypes.func,
  handleClose: PropTypes.func,
  hasApiError: PropTypes.bool,
  modals: PropTypes.array,
  purpose: PropTypes.string,
  purposeIsCompleted: PropTypes.bool,
  site: PropTypes.shape({
    id: PropTypes.number,
    sitePreferences: PropTypes.object,
  }),
  updateSitePreferences: PropTypes.func,
}

const mapper = entry => {
  const { modals, flowLabel } = entry || {}
  return {
    modals,
    flowLabel,
  }
}

const options = {
  entryId: '3BsWYN9mcO7XwBukv2hvR2',
  include: 3,
  mapper,
  spread: true,
}

export default ContentEntryDataGetter(
  withApiError(
    PurposeModalContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
